<template>
  <div class="security-captcha-page">
    <div class="card">
      <h1>安全验证</h1>
      <p class="hint">当前访问过于频繁，请完成图形验证码后继续。</p>

      <div class="captcha-row">
        <el-input
          v-model="captcha"
          placeholder="请输入验证码"
          maxlength="8"
          @keyup.enter="submit"
        />
        <img
          v-if="captchaImage"
          :src="captchaImage"
          alt="验证码"
          class="captcha-img"
          @click="refreshCaptcha"
        />
      </div>

      <el-button type="primary" :loading="loading" class="submit-btn" @click="submit">
        验证并继续
      </el-button>
      <el-button link type="primary" @click="refreshCaptcha">换一张</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { createCaptchaRefresher } from '@/utils/captchaCooldown'

export default {
  name: 'SecurityCaptchaView',
  data() {
    return {
      captcha: '',
      captchaId: '',
      captchaImage: '',
      loading: false
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    // 图形验证码：防连续点击，上一次完成后 2s 内不再重复获取
    refreshCaptcha: createCaptchaRefresher(async function () {
      try {
        const res = await axios.get('/api/v1/user/captcha')
        if (res.data?.code === 200 && res.data.data) {
          this.captchaId = res.data.data.captchaId
          this.captchaImage = res.data.data.imageBase64
        }
      } catch (e) {
        this.$message.error('获取验证码失败')
      }
    }),
    async submit() {
      if (!this.captcha || !this.captchaId) {
        this.$message.warning('请输入验证码')
        return
      }
      this.loading = true
      try {
        const res = await axios.post('/api/v1/security/captcha/verify', {
          captchaId: this.captchaId,
          captcha: this.captcha
        })
        if (res.data?.code === 200) {
          this.$message.success(res.data.message || '验证通过')
          const redirect = this.$route.query.redirect
          if (redirect && typeof redirect === 'string' && redirect !== '/security/captcha') {
            this.$router.replace(redirect)
          } else {
            this.$router.replace('/')
          }
          return
        }
        this.$message.error(res.data?.message || '验证失败')
        this.refreshCaptcha()
      } catch (e) {
        this.$message.error(e.response?.data?.message || '验证失败')
        this.refreshCaptcha()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.security-captcha-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.card {
  width: 100%;
  max-width: 420px;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
}
.hint {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}
.captcha-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}
.captcha-img {
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
}
.submit-btn {
  width: 100%;
  margin-bottom: 8px;
}
</style>
